// extracted by mini-css-extract-plugin
export default {"removeTopPaddingOnMobile":"AggregatedProductPage_removeTopPaddingOnMobile__tBd5u"};